import { StatRing } from './StatRing';

interface ProgressBarProps {
    current: number | null;
    total: number | null;
}

const PROGRESS_COLOR = '#10b981';

function ProgressBar({ current, total }: ProgressBarProps) {
    const hasData = current != null && total != null && total > 0;
    const pct = hasData ? Math.min(Math.round((current / total) * 100), 100) : null;

    return (
        <StatRing
            pct={pct}
            color={PROGRESS_COLOR}
            label={hasData ? `Aligner ${current}/${total}` : ''}
            sublabel={hasData ? `${total - current} remaining` : 'No aligner data'}
            emptyLabel="Progression"
        />
    );
}

export { ProgressBar };
